import { AppMinBirthValidatorDirective } from './utils/min-birth-validator';
import { AppMinoreValidatorDirective } from './utils/minore-validator';
import { AppConfermaMailValidatorDirective } from './utils/conferma-mail-validator';
import { JwtInterceptorService } from './core/services/jwt-interceptor.service';
import { AppSessoCFValidatorDirective } from './utils/sesso-cf-validator';
import { AppCognomeCFValidatorDirective } from './utils/cognome-cf-validator';
import { AppNomeCFValidatorDirective } from './utils/nome-cf-validator';
import { AppCodiceFiscaleValidatorDirective } from './utils/codice-fiscale-validator';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CoreModule } from './core/core.module';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { ReactiveFormsModule, NG_VALIDATORS } from '@angular/forms';
import { PraticaComponent } from './components/pratica/pratica.component';
import { PraticaIndexComponent } from './components/pratica/pratica-index/pratica-index.component';
import { PraticaHeaderComponent } from './components/pratica/pratica-header/pratica-header.component';
import { PraticaBodyComponent } from './components/pratica/pratica-body/pratica-body.component';
import { PraticaActionsComponent } from './components/pratica/pratica-actions/pratica-actions.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TestModalComponent } from './components/modals/test-modal/test-modal.component';
import { PraticaInfoRowComponent } from './components/pratica/pratica-info-row/pratica-info-row.component';
import { BackOfficeFooterComponent } from './components/back-office/back-office-footer/back-office-footer.component';
import { BackOfficeHeaderComponent } from './components/back-office/back-office-header/back-office-header.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { BackOfficeHeaderBannerComponent } from './components/back-office/back-office-header/back-office-header-banner/back-office-header-banner.component';
import { BackOfficeHeaderApplicationComponent } from './components/back-office/back-office-header/back-office-header-application/back-office-header-application.component';
import { BackOfficeHeaderMenuComponent } from './components/back-office/back-office-header/back-office-header-menu/back-office-header-menu.component';
import { BackOfficeHeaderNavigationComponent } from './components/back-office/back-office-header/back-office-header-navigation/back-office-header-navigation.component';
import { FormsModule } from '@angular/forms';
import { RicercaPraticaComponent } from './components/back-office/ricerca-pratica/ricerca-pratica.component';
import { BackOfficeFilterComponent } from './components/back-office/ricerca-pratica/back-office-filter/back-office-filter.component';
import { BackOfficePraticaTableComponent } from './components/back-office/ricerca-pratica/back-office-pratica-table/back-office-pratica-table.component';
import { MatChipsModule, MatCheckboxModule, MatSelectModule, MatPaginatorModule, MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule, MatSpinner } from '@angular/material';
import { StylePaginatorDirective } from './directives/style-paginator.directive';
import { BackOfficeBaseSearchComponent } from './components/back-office/ricerca-pratica/back-office-base-search/back-office-base-search.component';
import { BackOfficeSearchBarComponent } from './components/back-office/ricerca-pratica/back-office-search-bar/back-office-search-bar.component';
import { BackOfficeAdvanceSearchComponent } from './components/back-office/ricerca-pratica/back-office-advance-search/back-office-advance-search.component';

import { BackOfficeFilterUtenteComponent } from './components/back-office/ricerca-utente/back-office-filter-utente/back-office-filter-utente.component';
import { RicercaUtenteComponent } from './components/back-office/ricerca-utente/ricerca-utente.component';
import { BackOfficeUtenteTableComponent } from './components/back-office/ricerca-utente/back-office-utente-table/back-office-utente-table.component';
import { BackOfficeBaseSearchUtenteComponent } from './components/back-office/ricerca-utente/back-office-base-search-utente/back-office-base-search-utente.component';
import { BackOfficeSearchBarUtenteComponent } from './components/back-office/ricerca-utente/back-office-search-bar-utente/back-office-search-bar-utente.component';
import { BackOfficeAdvanceSearchUtenteComponent } from './components/back-office/ricerca-utente/back-office-advance-search-utente/back-office-advance-search-utente.component';

import { MAT_DATE_LOCALE, MatTableModule, MatSortModule } from '@angular/material';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FrontOfficeService } from './services/front-office.service';
import { FrontOfficeModule } from './components/front-office/front-office.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ControlErrorComponent } from './directives/control-error.component';

import { ModalComponent } from './core/components/modal/modal.component';
import { DialogContentExampleDialog } from './core/components/dialog-content-example-dialog/dialog-content-example-dialog.component';
import { RicercaUtenteDetailComponent } from './components/back-office/ricerca-utente-detail/ricerca-utente-detail.component';
import { NuovoUtenteComponent } from './components/back-office/nuovo-utente/nuovo-utente.component';
import { OrganicoInterrogatorService } from './services/organico-interrogator.service';
import { ErrorFormDirective } from './directives/error-form.directive';
import { ControlErrorContainerDirective } from './directives/control-error-container.directive';
import { BackOfficeLandingPageComponent } from './components/back-office/back-office-landing-page/back-office-landing-page.component';
//import { LoadingTemplateComponent } from './directives/components/loading-template/loading-template.component';
import { AppConfigService } from './services/app-config.service';

export function appInit(appConfigService: AppConfigService) {
    return () => appConfigService.load();
}

@NgModule({
    declarations: [
        AppComponent,
        TestModalComponent,
        StylePaginatorDirective,
        ModalComponent,
        DialogContentExampleDialog
    ],
    imports: [
        BrowserModule,
        MatTableModule,
        MatSortModule,
        AppRoutingModule,
        CoreModule,
        RxReactiveFormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }), // .forRoot(),
        TranslateModule,
        FormsModule,
        MatPaginatorModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSelectModule,
        MatButtonModule,
        MatCheckboxModule,
        MatChipsModule,
        MatIconModule,
        HttpClientModule
    ],
    providers: [{ provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
        // FrontOfficeService,
        OrganicoInterrogatorService,
        FrontOfficeService,
        {
            provide: NG_VALIDATORS,
            useExisting: AppCodiceFiscaleValidatorDirective,
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: AppNomeCFValidatorDirective,
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: AppCognomeCFValidatorDirective,
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: AppSessoCFValidatorDirective,
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: AppConfermaMailValidatorDirective,
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: AppMinoreValidatorDirective,
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: AppMinBirthValidatorDirective,
            multi: true
        },
        AppConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: appInit,
            multi: true,
            deps: [AppConfigService]
        },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true }
    ],
    entryComponents: [TestModalComponent,
        ControlErrorComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './public/api/assets/i18n/', '.json');
}
